import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import {Component} from "react"
import {Link} from "react-router-dom"
import {Card} from "semantic-ui-react"

export default class CategoryCard extends Component {

	render() {
		const {category, hasParents, className = "", title = true, fallback = "//placehold.it/420x240/f5f5f5/&text="} = this.props

		if ( !hasParents ) {
			return <Card className={`CategoryCard ${className}`} as={Link}
						 to={`/collection/${category.map_id}`}>
				<ImageWithFallback src={category.img_src} fallback={fallback} />
				<div className="onIdle pa3 absolute bottom-0 left-0 fw4">
					<span className="category-title dark-gray f2 lh-copy fw6">{category.desc.short_des}</span>
				</div>

				{title && <div className={"onHover pa3 text-box"}>
					<span className="category-title">{category.desc.short_des}</span>
				</div>}

			</Card>
		}

		if ( category.getParents ) {
			let parents = category.getParents()
			return <Card className={`CategoryCard ${className}`} as={Link}
						 to={`/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}`}>
				<ImageWithFallback src={category.img_src} fallback={"https://luki.trend-soft.de/shop/rest/data/images/description/Arbeitsschutz/1?size=large"} />
				<div className="onIdle pa3 absolute bottom-0 left-0 fw4">
					<span className="category-title dark-gray f2 lh-copy fw6">{category.desc.short_des}</span>
				</div>

				{title && <div className={"onHover pa3 text-box"}>
					<span className="category-title">{category.desc.short_des}</span>
				</div>}
			</Card>
		}

		return null
	}
}


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/plugin/CategoryShortcuts/CategoryCard.js